




















































































































import Enumerable from "linq";
import { Vue, Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { IDocumentImageSource } from "../../../../domain/document";
import {
  IItem,
  IDrawableItem,
} from "../../../../domain/document/items";
import { FixedLoading } from "../../../system";
import { StandardKeyboardHandler } from "../../../system/keyboard";
import { DraggableAreaManagerMixin } from "../../../dragging/mixins";
import DrawableObject from "../DrawableObject.vue";
import DrawableObjectMenu from "../DrawableObjectMenu.vue";
import DocumentPageMenu from "../DocumentPageMenu.vue";
import FocusIndicator from "../FocusIndicator.vue";
import ObjectLocator from "../ObjectLocator.vue";
import { FixedPhraseTextDropManager, IFixedPhraseTextDragParameter, ImageDropManager } from "../../../dragging";
import {
  EditingDocumentDrawableMixin,
  DocumentEditableMixin,
  DocumentObjectLazyDrawableMixin,
  CommonComponentsAccessibleMixin,
} from "./../mixins";
import {
  EditingDocument,
  IDrawableItemEditable,
  instanceOfIDrawableItemEditable,
  instanceOfIKeyboardEventHandleable,
  IOffsetInformation,
  ObjectMarkKinds,
} from "..";
import { IConfiguration } from "../../../../domain/configuration";
import PageBorderLine from "./PageBorderLine.vue";
import { PdfStyleDrawableMixin } from "../../../system/mixins";
import { ObjectClipboardMixin } from "../objects/mixins";
import { Department } from "../../../../domain/department";
import { DepartmentHisObjectsUpdater, DepartmentRelatedHisInformationApplicator } from "../helpers";
import { HisInformationProcessResultConverter } from "../../../his/components/helper";

@Component({
  components: {
    FixedLoading,
    // DcCoreとして考えると、DrawableObjectはユーザ実装.(対象のComponentはここで定義されるので.)
    drawableObject: DrawableObject,
    DrawableObjectMenu,
    DocumentPageMenu,
    focusIndicator: FocusIndicator,
    locator: ObjectLocator,
    PageBorderLine,
    StandardKeyboardHandler,
  },
})
export default class DocumentPageEditor extends Mixins<
  EditingDocumentDrawableMixin
  & DocumentEditableMixin
  & DocumentObjectLazyDrawableMixin
  & DraggableAreaManagerMixin
  & CommonComponentsAccessibleMixin
  & PdfStyleDrawableMixin
  & ObjectClipboardMixin
>(
  EditingDocumentDrawableMixin,
  DocumentEditableMixin,
  DocumentObjectLazyDrawableMixin,
  DraggableAreaManagerMixin,
  CommonComponentsAccessibleMixin,
  PdfStyleDrawableMixin,
  ObjectClipboardMixin,
) {
  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  data(): any {
    return {
      isDocumentAlreadyInitialized: false,
      isErasing: false,
      isLayerImageloaded: true,
    };
  }
  isDocumentAlreadyInitialized: boolean;
  isErasing: boolean; // 消しゴム中はv1以降自由描画オブジェクトの2重表示を抑止するために管理.
  isLayerImageloaded: boolean;

  // 外部処理を定期的に実行するためのタイマー
  scriptExecuteTimer: any;

  getLocator(): ObjectLocator {
    return this.$refs.locator as ObjectLocator;
  }

  get lastFocusedObject(): IDrawableItemEditable {
    return this.readPropertyOrDefault(s => s.lastFocusedObject, null);
  }

  set lastFocusedObject(value: IDrawableItemEditable) {
    this.writePropertyWhenValid(s => s.lastFocusedObject = value);
  }

  get isImageRegistrationEnable(): boolean {
    return this.readPropertyOrDefault(s => !s.isImageRegistrationDisabled, true);
  }

// isDocumentAlreadyInitializedは算出オブジェクトとして以下の算出オブジェクトとして実装していたが、IEで上手く動かなかった.
// ログを出した所、最後に呼ばれたisDocumentAlreadyInitializedは想定通りtrueを返しているにも関わらず、
// それがfalseであるかのように描画されている.(算出オブジェクトのキャッシュはVue.jsが行ってる...Vue.jsのIE実装のバグ？)
// 別途データとして持てば現象を回避できたので、データとして持って初期化完了時にはそのデータも更新するようにして回避.
//  get isDocumentAlreadyInitialized(): boolean {
//    return this.isSourceEnable
//      && this.editingSource.isAlreadyInitialized;
//  }

  @Watch("lastFocusedItem")
  onLastFocusedItemUpdated(newValue: IItem, oldValue: IItem): void {
    if (newValue === null) {
      this.resetFocus();
    } else if (newValue && (!oldValue || (newValue.privateId !== oldValue.privateId))) {
      // 今までフォーカスが当たってたitemと別のitemにフォーカス当たった場合のみ入力フォーカスを当てる.
      // (今まで当たってるitemに再度当てると、そのタイミングでime-mode再設定される等の副作用があるため.)
      this.inputableElementFocus();
    }
  }

  onEditorMouseDowned(event: PointerEvent): void {
    this.lastFocusedItem = null;
  }

  onPageMouseDowned(event: PointerEvent): void {
    // refs定義しようかと思ったが、実装済のオブジェクトのrefは動的に決まるので定義できない.キャストで対応.
    (this.$refs.pageMenu as DocumentPageMenu).handlePageMouseClicked(event);
  }

  onObjectMouseDowned(sender: IDrawableItemEditable, event: PointerEvent): void {
    (this.$refs.objectMenu as DrawableObjectMenu).handleObjectMouseClicked(sender, event);
  }

  private updateLastFocusedObject(): void {
    if ((!this.lastFocusedObject && !this.lastFocusedItem)
     || (this.lastFocusedObject && !this.isDifferentItem(this.lastFocusedObject.editingSource, this.lastFocusedItem))) {
      return;
    }
    const found = this.foundLastFocusedObject();
    if (this.lastFocusedObject !== found) {
      this.lastFocusedObject = found;
    }
  }

  private foundLastFocusedObject(): IDrawableItemEditable {
    if (!this.lastFocusedItem) {
      return null;
    } else {
      const refs = this.$refs[this.toObjectKey(this.lastFocusedItem)] as Vue[];
      const ref = (refs && (0 < refs.length))
        ? refs[0]
        : null;
      return (ref && instanceOfIDrawableItemEditable(ref.$refs.obj))
        ? ref.$refs.obj
        : null;
    }
  }

  private isDifferentItem(newValue: IItem, oldValue: IItem): boolean {
    if (newValue === oldValue) { return false; }
    if (!!newValue && !oldValue || !newValue && !!oldValue) { return true; }
    return (newValue && oldValue && newValue.privateId !== oldValue.privateId);
  }

  @Watch("scale")
  onScaleUpdated(newValue: number, oldValue: number) {
    // scaleはDraggableAreaManagerMixinのデータなので監視して連動させる.
    if (this.editingSource.scale !== newValue) {
      this.writeProperty(s => s.scale = newValue);
    }
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: EditingDocument, oldValue: EditingDocument) {
    if (oldValue && oldValue.isAlreadyInitialized && newValue && !newValue.isAlreadyInitialized) {
      this.$logger.error("一度初期化完了したはずの文書の初期化が無効になりました.実装に問題ないかを確認してください.(問題ないのであればこのログは削除してください.)");
    }
    if (newValue) {
      // scaleはDraggableAreaManagerMixinのデータなので監視して連動させる.
      if (this.scale !== newValue.scale) {
        this.scale = newValue.scale;
      }
      if (!this.isDocumentAlreadyInitialized && newValue.isAlreadyInitialized) {
        this.$logger.info("文書の初期化が完了しました.操作のロックを解除します.");
        this.unlockManualInput();
        this.showHisInformationAlerts();
      }
    }
    // lastFocusedItem更新時に行ってたが、editingSource更新の輻輳で更新後に上書きされちゃってる模様.
    // editingSource更新時にlastFocusedItemとlastFocusedObjectのソースが違う場合は更新するように変更する.(同方向チェック必須.)
    if (newValue && this.isDifferentItem(newValue.lastFocusedItem, newValue.lastFocusedObject ? newValue.lastFocusedObject.editingSource : null)) {
      // item追加時はまだ$refsでアクセスできないので次のメインループで実行.
      this.$nextTick(() => {
        this.updateLastFocusedObject(); // 遅延描画対応で効いてないが念のため.
      });
    }
  }

  private showHisInformationAlerts(): void {
    try {
      const message = HisInformationProcessResultConverter.toMessageText((this.editingSource as EditingDocument).source.hisInformation.processResult);
      if (!message) { return; }
      this.$info("患者情報取得" , message + this.$configuration.wording.document.editor.hisInformationAlertAdditionalDescription);
    } catch (e) {
      // エラーは起こさないようにしているが念のため
      this.$logger.error("情報取得失敗の通知処理中にエラーが発生しました。");
      this.$logger.error(e);
    }
  }

  get shouldInputFreeAll(): boolean {
    return this.readPropertyOrDefault(s => s.shouldInputFreeAll, false);
  }

  get shouldMarkQuote(): boolean {
    return this.readPropertyOrDefault(s => s.shouldMarkQuote, false);
  }

  get shouldDrawEditStyle(): boolean {
    return this.readPropertyOrDefault(s => s.shouldDrawEditStyle, true);
  }

  get shouldDrawTransparentAll(): boolean {
    return this.readPropertyOrDefault(s => s.shouldDrawTransparentAll, false);
  }

  get scaledStyle(): any {
    // transform scaleを指定するとelement-uiのel-dialogのモーダル表示がおかしくなってしまう
    // modalAppendToBody="false"を指定するとモーダル表示は正しくなるが、文書編集画面のscrollに依存する表示になってしまう
    // appendToBody="true"を指定すると概ね良さそうな表示になる。親から引き継がれていたcss指定が無くなるのでそこだけ注意が必要
    return {
      transform: "scale(" + this.scale + ", " + this.scale + ")",
      transformOrigin: "left top",
    };
  }

  focused(source: IDrawableItemEditable): void {
    // 初期化が終わる前にフォーカスを更新するとフォーカス更新と初期化の更新がパラで走ってしまい更新がおかしくなる。(単一データフローなので。)
    // 初期化が終わるまではフォーカスの移動は無視する。
    if (!this.editingSource || !this.editingSource.isAlreadyInitialized) { return; }
    this.lastFocusedItem = (source && source.editingSource && source.editingSource.privateId !== null && source.editingSource.privateId !== undefined)
      ? this.items[source.editingSource.privateId]
      : null;
  }

  focusLost(source: IDrawableItemEditable): void {
    this.lastFocusedItem = null;
  }

  toObjectKey(value: IItem): string {
    // privateIdだけだと続紙を追加したときなどに一意のkeyにならないので
    // itemSetIdを合わせてオブジェクトのkeyとする
    // フォーマット最新化したときに異なるキーとしたいので、formatIdも追加している
    return "object-" + this.attributes.format.id + "-" + this.itemSetId + "-" + value.privateId;
  }

  isLastFocusedItem(value: IItem): boolean {
    // 判定に!!を付与しないと戻り値がnullになる模様
    // isFocusedをwatchしているところがnullとfalseで反応してしまうので注意
    return !!this.lastFocusedItem && !!this.currentSection
      && value.privateId === this.lastFocusedItem.privateId
      && (this.sections.length === 1 || this.currentSection.itemPrivateIds.indexOf(this.lastFocusedItem.privateId) !== -1);
  }

  getObjectMarkKind(value: IItem): ObjectMarkKinds {
    const alertKind = this.getObjectAlertMarkKind(value);
    if (alertKind) {
      return alertKind;
    }
    const injectedKind = this.getObjectInjectedMarkKind(value);
    if (injectedKind) {
      return injectedKind;
    }
    return null;
  }

  getObjectAlertMarkKind(value: IItem): ObjectMarkKinds {
    if (!this.shouldMarkAlerts) {
      return null;
    }
    // TODO: itemSetIdを気にしないでよいのか疑問あり
    const found = Enumerable.from(this.alerts).firstOrDefault(a => !!a.detectedItem && a.detectedItem.privateId === value.privateId);
    if (!found) { return null; }
    return found.isError
      ? ObjectMarkKinds.Error
      : ObjectMarkKinds.Warning;
  }

  getObjectInjectedMarkKind(value: IItem): ObjectMarkKinds {
    if (!this.shouldMarkInjected) {
      return null;
    }
    const found = this.readPropertyOrDefault(s => s.findInjectedObject(value), null);
    if (!found) {
      return null;
    }
    return ObjectMarkKinds.Primary;
  }

  get layerImageWidth(): number {
    return this.layerImageRectangle.width;
  }

  get layerImageHeight(): number {
    return this.layerImageRectangle.height;
  }

  mounted() {
    this.commonComponents.editors.page.setEditor(this);
    // ESCキーはApp.vueで伝播止められてるのでwindowに直接listnerを追加する.
    window.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.key === "Esc" || event.key === "Escape") {
        this.lastFocusedItem = null;
      }
    });
    if (this.editingSource && this.editingSource.isAlreadyInitialized) {
      this.unlockManualInput();
    }
    this.$registerErasingChangedHandler(i => this.isErasing = i);
  }

  private async unlockManualInput(): Promise<void> {
    this.isDocumentAlreadyInitialized = true;
    this.scale = this.getDefaultScale();
    const config = this.$store.getters.configuration as IConfiguration;
    if (config.behavior.document.editor.extraPageAdditionAtInitialization.isEnable) {
      this.$nextTick(() => {
        // 長い文字列のHIS項目で続紙追加ダイアログを出す対応
        // この機能は徳島大に入っている系列のDocuにしか入っていない
        const isNewDocument = (this.editingSource.source.documentId === null || this.editingSource.source.documentId === undefined);
        if (isNewDocument) {
          this.commonComponents.editors.extraPage.addAllOverflowedTextPage();
        }
      });
    }
    const intervalMilliSeconds = config.behavior.document.editor.externalScript.executeIntervalMilliSeconds;
    // タイマーを使わない場合はDocumentStructureEditableMixinのupdateItem()でexecuteStackedScripts()を実行している
    if (intervalMilliSeconds > 0) {
      // UrlSchemeの連続起動でexe起動ができない問題について、Chromeでは4秒程度間隔を空けないと発生するのは既知だったが、
      // IEでもタイミングによっては発生することが判明した。
      // IEではキー連打等により実行するタイミングが重なる現象発生する模様なので、対策として一定時間ごとに実行するように対策している。
      // 今後Chrome対応する際には、前回実行時間と比較して、充分に間隔が空いていたら即座に実行する機能を実装する必要があると思われる。
      if (!this.scriptExecuteTimer) {
        this.$logger.info("外部処理の定期実行タイマーを開始します.");
        this.scriptExecuteTimer = setInterval(this.executeStackedScripts, intervalMilliSeconds);
      }
    }
  }

  private getDefaultScale(): number {
    const configuredScaleAsPercentage = this.$configuration.behavior.document.editor.documentAttributes.scale.defaultScaleAsPercentage;
    return !!configuredScaleAsPercentage && configuredScaleAsPercentage > 0
      ? (configuredScaleAsPercentage / 100)
      : (this.attributes ? this.attributes.defaultScale : 1.0);
  }

  beforeDestroy() {
    if (this.scriptExecuteTimer) {
      clearInterval(this.scriptExecuteTimer);
    }
  }

  onDragOver(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
  }

  onDrop(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();

    try {
      const textDropManager = new FixedPhraseTextDropManager(
        event,
        this.$refs.page as HTMLDivElement,
        this.scale,
        this.$measureTextDrawnSize,
        this.addItem,
        p => this.createDroppedPhrase(p),
      );
      const imageDropManager = new ImageDropManager(
        (title, message, error) => { this.$error(title, message, error); },
        this.addItem,
        this.$refs.page as HTMLDivElement,
        this.scale,
        event,
        this.createImageSource,
        this.patientAttribute,
      );
      // 非同期で実行したとき、awaitの後でevent.dataTransferが空になる現象があり、eventから事前に値を取得しておくことで対策している
      this.onDropAsync(textDropManager, imageDropManager);
    } catch (e) {
      this.$error("貼り付け失敗", "貼り付け処理に失敗しました。", e);
    }
  }

  private async createDroppedPhrase(parameter: IFixedPhraseTextDragParameter): Promise<string> {
    if (!parameter.isAiPhrase) {
      return parameter.text;
    }
    const result = await this.commonComponents.dialogs.aiPhrase.show({
      template: parameter.text,
      actions: {
        locate: true,
      },
    });
    return (result.isConfirmed && (result.action === "locate"))
      ? result.phrase
      : null;
  }

  private async onDropAsync(textDropManager: FixedPhraseTextDropManager, imageDropManager: ImageDropManager): Promise<void> {
    try {
      if (await textDropManager.run()) {
        return;
      }
      if (this.$configuration.behavior.document.editor.imageDropper.isEnable) {
        await imageDropManager.run();
      }
    } catch (e) {
      this.$error("貼り付け失敗", "貼り付け処理に失敗しました。", e);
    }
  }

  prohibitDropEvent(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = "none";
  }

  /**
   * タブの移動で編集画面の外にフォーカスが迷子になってしまわないように対策
   */
  resetFocus(): void {
    const target = this.$refs.focusTarget as HTMLElement;
    if (!!target) { target.focus(); }
  }

  inputableElementFocus(): void {
    if (this.lastFocusedItem && this.lastFocusedObject &&
      this.lastFocusedItem.privateId === this.lastFocusedObject.editingSource.privateId &&
      this.lastFocusedObject.inputableElement) {
      this.lastFocusedObject.inputableElement.focus();
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (!this.lastFocusedObject || !instanceOfIKeyboardEventHandleable(this.lastFocusedObject)) {
      return;
    }
    if (this.lastFocusedObject.handleKeyboardEvent(event)) {
      event.preventDefault();
    }
  }

  handleItemLocated(located: IDrawableItem): void {
    // 新規オブジェクト追加時、フォーカスをeditor上に移しておかないと、キー拾えない.
    (this.$refs.editor as HTMLElement).focus();
  }

  handleDeleted(): boolean {
    if (this.lastFocusedItem && this.isItemRemovable(this.lastFocusedItem)) {
      this.removeItem(this.lastFocusedItem);
      return true;
    }
    return false;
  }

  handleCopied(): boolean {
    if (!this.lastFocusedObject || !this.getObjectCopyable(this.lastFocusedObject.editingSource, true)) {
      return false;
    }
    this.copyToObjectClipboard(this.lastFocusedObject.editingSource);
    return true;
  }

  async handlePasted(): Promise<boolean> {
    if (this.lastFocusedObject && !this.getObjectCopyable(this.lastFocusedObject.editingSource)) {
      return false;
    }
    const item = await this.getNewObjectFromObjectClipboard();
    this.copyToObjectClipboard(item); // 連続してペーストする際、重ならないようコピーし直す
    this.addItem(item);
  }

  @Watch("currentPage")
  onCurrentPage(newValue: number, oldValue: number): void {
    // ページ遷移が起こった時にスクロールを初期位置に戻す
    this.resetScrollPosition();
  }

  private resetScrollPosition(): void {
    const editor = this.$refs.editor as HTMLDivElement;
    if (!editor) { return; }
    editor.scrollTop = 0;
    editor.scrollLeft = 0;
  }

  /**
   * v-loadingのぐるぐる表示中もスクロールが可能になっていて、
   * スクロールさせるとオブジェクトの操作可能になってしまっているため、
   * 初期化が終わるまでは操作不能にしている。
   */
  get pointerEventsStyle(): any {
    return this.isDocumentAlreadyInitialized
      ? null
      : { pointerEvents: "none" };
  }

  get layerImageloadingStyle() {
    return !this.isLayerImageloaded
      ? {
        visibility: "hidden"
      }
      : null;
  }

  @Watch("layerImageSource")
  onLayerImageSourceUpdated(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.isLayerImageloaded = false;
    }
  }

  setLayerImageloaded() {
    this.isLayerImageloaded = true;
  }

  getOffset(): IOffsetInformation {
    const element = this.$refs.editor as HTMLDivElement;
    if (!element) { return null; }

    const clientRect = element.getBoundingClientRect();
    return {
      top: clientRect.top,
      left:  clientRect.left,
      scrollTop:  element.scrollTop,
      scrollLeft:  element.scrollLeft,
    };
  }

  @Watch("departmentAttributeWithUndefined")
  onDepartmentAttributeUpdated(newValue: Department, oldValue: Department): void {
    const config = this.$configuration.behavior.document.editor.documentAttributes.department;
    const departmentRelatedInformations = !!this.hisInformation && !!this.hisInformation.departmentRelatedInformations
      ? this.hisInformation.departmentRelatedInformations
      : [];
    if (!config.shouldUpdateDepartmentHisObjectsWhenChanged && departmentRelatedInformations.length === 0) {
      // 処理対象無し
      return;
    }
    const newId = newValue ? newValue.id : null;
    const oldId = oldValue ? oldValue.id : null;
    if (!this.isEditingDocumentAlreadyInitialized || oldValue === undefined || newId === oldId) {
      // 文書初期化直後に必ず更新されるが、そのときはoldValueがundefinedになるようにしている
      // editingSourceもしくはattributesのWatchでは更新前のdepartmentを取得できず断念している
      // (診療科を選択したときも結局はEditingDocumentのcloneとなり、DocumentAttributesのインスタンスはcloneされないため)
      return;
    }
    // WF文書は文書編集開始する前のタイミングで診療科を自動的に依頼の診療科に変更する機能がある
    // 現状ではそこまでの対応できていないが、対応する際には何らかのフラグを受け取って変更する処理が必要になる見込み
    this.$logger.info("文書内のHISオブジェクトを連動更新します。");
    try {
      this.writePropertyWhenValid(d => {
        if (config.shouldUpdateDepartmentHisObjectsWhenChanged) {
          const updater = new DepartmentHisObjectsUpdater(d);
          updater.apply(newValue);
        }
        if (departmentRelatedInformations.length > 0) {
          const applicator = new DepartmentRelatedHisInformationApplicator(d);
          applicator.apply(newValue);
        }
      });
    } catch (e) {
      this.$error("診療科連動更新", "診療科連動更新に失敗しました。", e);
    }
  }
}
